<template>
  <div>
    <v-container>
      <v-card>        
        <v-card-text>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              File Standar Dokumen Pengadaan
            </v-col>              
            <v-col cols="1" >
              <v-btn v-if="fileSDP !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileSDP', fileSDP, false)"><v-icon>get_app</v-icon> </v-btn>
            </v-col>              
            <v-col cols="8" >
              <v-file-input accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" v-model="uploadFileSDP" :placeholder="fileSDP" :disabled="readonly" dense />
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              File Administrasi
            </v-col>              
            <v-col cols="1" >
              <v-btn v-if="fileAdministrasi !== ''" icon color="green" @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileAdministrasi', fileAdministrasi, false)"><v-icon>get_app</v-icon> </v-btn>
            </v-col>              
            <v-col cols="8" >
              <v-file-input accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" v-model="uploadFileAdministrasi" :placeholder="fileAdministrasi" :disabled="readonly" dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              File Teknis
            </v-col>              
            <v-col cols="1" >
              <v-btn icon color="green" v-if="fileTeknis !== ''"
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileTeknis', fileTeknis, false)"><v-icon>get_app</v-icon>
              </v-btn>
            </v-col>              
            <v-col cols="8" >
              <v-file-input accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" v-model="uploadFileTeknis" :placeholder="fileTeknis" :disabled="readonly" dense />
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="3" class="yellow lighten-4 font-weight-bold">
              File Tambahan
            </v-col>              
            <v-col cols="1" >
              <v-btn icon color="green" v-if="fileTambahan !== ''"
                @click.prevent="tenderLib.getFileDownloadLink(paket.id, 'FileTambahan', fileTambahan, false)"><v-icon>get_app</v-icon>
              </v-btn>
            </v-col>              
            <v-col cols="8" >
              <v-file-input accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" v-model="uploadFileTambahan" :placeholder="fileTambahan" :disabled="readonly" dense />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" class="yellow lighten-4"></v-col>
            <v-col><v-btn v-if="!readonly" color="green" dark @click="uploadFiles()">Upload File</v-btn></v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-container>
    
    <UndanganVendor :tipe="'L'" :readonly="readonly" />


    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{notification.text}}
    </v-snackbar>
  </div>
</template>

<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { TenderLib } from "./../../../lib/tenderLib";
import UndanganVendor from "./../UserUndanganVendor"


export default {
  components: {
    UndanganVendor
  },

  props: {
      readonly: {
          type: Boolean,
          default: false
      },
  },

  data() {
      return {
        tenderLib: TenderLib,

        // fileAdministrasi: "",
        // fileTeknis: "",
        fileSDP: "",
        fileTambahan: "",
        // uploadFileAdministrasi: null,
        // uploadFileTeknis: null,
        uploadFileSDP: null,
        uploadFileTambahan: null,

        // Notification
        notification: {
            show: false,
            color: "",
            text: ""
        },
      }
  },

  computed: {
      paket: function() {
          return this.$store.getters['lelang/paket']
      },
  },

  watch: {
      paket() {
          this.getData();
      }
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      axios.get(`${apiUrl}/api/lelang/prakualifikasi/upload/${this.paket.id}`)
      .then( (response) => {
        console.log("UserUndanganLulusKualifikasi-Files-Response: ", response.data);
        // if (response.data.fileAdministrasi) this.fileAdministrasi = response.data.fileAdministrasi;
        // if (response.data.fileTeknis) this.fileTeknis = response.data.fileTeknis;
        if (response.data.fileSDP) this.fileSDP = response.data.fileSDP;
        if (response.data.fileTambahan) this.fileTambahan = response.data.fileTambahan;
      })
      .catch( (error) => {
        console.error(error);
      });
    },

    uploadFiles() {
      // if (this.uploadFileAdministrasi == null && this.uploadFileTeknis == null && this.uploadFileTambahan == null) {
      if (this.uploadFileSDP == null && this.uploadFileTambahan == null) {
        this.notification = {
          show: true,
          color: "error",
          text: "Masukkan minimal 1 (satu) file terbaru sebelum upload"
        }

        return;
      }

      const fdata = new FormData()
      fdata.append('paketPenyediaId', this.paket.id);
      // fdata.append('fileAdministrasi', this.uploadFileAdministrasi);
      // fdata.append('fileTeknis', this.uploadFileTeknis);  
      fdata.append('fileSDP', this.uploadFileSDP);
      fdata.append('fileTambahan', this.uploadFileTambahan); 

      axios.post(`${apiUrl}/api/lelang/prakualifikasi/upload`, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
      .then( (response) => {
          // this.fileAdministrasi = response.data.fileAdministrasi;
          // this.fileTeknis = response.data.fileTeknis;
          this.fileSDP = response.data.fileSDP;
          this.fileTambahan = response.data.fileTambahan;

          this.notification = {
              show: true,
              color: "success",
              text: `File berhasil diupload`
          };
      })
      .catch( (error) => {
          this.notification = {
              show: true,
              color: "error",
              text: `[${error.message}] Gagal upload file`
          }
      });

    },
    
  }
    
}
  
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>
